"use client";

import PropTypes from "prop-types";
import { useAppContext } from "@components/Provider";
import NextImage from "./NextImage";

const Image = (props) => {
  const { isMobile } = useAppContext();

  return <NextImage {...props} isMobile={isMobile} />;
};

Image.propTypes = {
  Name: PropTypes.string,
  Caption: PropTypes.object,
  Alt_Text: PropTypes.string,
  Credited: PropTypes.string,
  Credit_Url: PropTypes.string,
  Link: PropTypes.object,
  ImageUrl: PropTypes.string,
};

export default Image;
